import React from "react";
import ListProduct from "./ListProduct";

interface VoucherConditionModalProps {
    open: boolean;
    onClose: () => void;
}

export default function VoucherConditionModal({
    open,
    onClose,
}: VoucherConditionModalProps) {
    if (!open) return null;

    return (
        <div
            role="presentation"
            className="MuiModal-root MuiDialog-root relative css-u14xag ctrl-p-0"
        >
            <div
                aria-hidden="true"
                className="MuiBackdrop-root css-919eu4"
                style={{
                    opacity: 1,
                    transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
                }}
            // onClick={onClose}
            />
            <div
                className="MuiDialog-container MuiDialog-scrollPaper css-ekeie0"
                role="presentation"
                style={{
                    opacity: 1,
                    transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
                }}
                onMouseDown={(e) => {
                    // chỉ đóng khi click vào nền container
                    if (e.target === e.currentTarget) {
                        onClose();
                    }
                }}
            >
                <div
                    className="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation24 MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthSm css-uhb5lp"
                    role="dialog"
                    aria-labelledby=":r0:"
                >
                    {/* CLOSE */}
                    <div className="absolute top-[20px] right-0 z-10">
                        <div
                            className="flex gap-2 items-center !text-white cursor-pointer"
                            onClick={onClose}
                        >
                            <p className="text-[14px]">Đóng</p>
                            <svg
                                className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium !text-white css-vubbuv"
                                focusable="false"
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                            >
                                <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                            </svg>
                        </div>
                    </div>

                    <div
                        data-root-voucher=""
                        className="w-[80vw] max-h-[1000px] h-[80vh] xl:w-[1028px] mx-auto px-0 space-y-4 font-[ggsm] overflow-x-hidden overflow-y-auto pb-3 bg-white w-full-767"
                        data-short-name="GIẢM 0.5%"
                        data-code="CHUYENKHOAN2602"
                        data-expired-date="2026-02-28T16:59:00Z"
                        data-action-status="INVALID"
                        data-usage-total="9985"
                    >
                        {/* HEADER */}
                        <div className="w-full rounded p-6 flex gap-6 bg-white ctrl-flex-col-991">
                            <div className="min-w-[360px] max-w-[40%] flex flex-col space-y-2">
                                <h3 className="text-[32px] font-bold line-clamp-2 text-black text-center">
                                    GIẢM 0.5%
                                </h3>

                                {/* <div className="h-[100px] min-w-[100px] relative !my-6 mx-auto">
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            overflow: "hidden",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: "0px",
                                            padding: "0px",
                                            position: "absolute",
                                            inset: "0px",
                                        }}
                                    >
                                        <img
                                            data-origin-url="https://storage.googleapis.com/thuocsi-live/images/2025c2634a8854f6fff28ec93e49311e"
                                            src="https://gcs.buymed.com/thuocsi-live/images/2025c2634a8854f6fff28ec93e49311e?quality=100"
                                            decoding="async"
                                            data-nimg="fill"
                                            style={{
                                                position: "absolute",
                                                inset: "0px",
                                                boxSizing: "border-box",
                                                padding: "0px",
                                                border: "none",
                                                margin: "auto",
                                                display: "block",
                                                width: "0px",
                                                height: "0px",
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                                minHeight: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                                objectPosition: "left center",
                                            }}
                                            alt=""
                                        />
                                    </span>
                                </div> */}

                                <div className="flex items-center gap-2 flex-wrap !mt-2">
                                    <p className="text-[16px] font-medium min-w-fit">
                                        Mã sử dụng:
                                    </p>

                                    <div className="flex items-center gap-2 max-w-[90%]">
                                        <span
                                            className="text-[#1D39C4] text-[16px] font-medium cursor-pointer line-clamp-1"
                                            onClick={() => navigator.clipboard.writeText("CHUYENKHOAN2602")}
                                        >
                                            CHUYENKHOAN2602
                                        </span>

                                        <svg
                                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium text-[#0E1983] !text-[18px] cursor-pointer css-vubbuv"
                                            focusable="false"
                                            aria-hidden="true"
                                            viewBox="0 0 24 24"
                                            data-testid="FileCopyOutlinedIcon"
                                            onClick={() => navigator.clipboard.writeText("CHUYENKHOAN2602")}
                                        >
                                            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z" />
                                        </svg>
                                    </div>
                                </div>

                                <p className="text-[#F53449] text-[16px] font-medium !mt-2">
                                    Hạn sử dụng: 28/02/2026
                                </p>

                                <div className="h-5 w-full rounded-[20px] bg-[#F0F0F0] flex items-center justify-center relative overflow-hidden !mt-2">
                                    <div
                                        className="bg-[#FFB951] absolute inset-0 z-1"
                                        style={{ width: "21%" }}
                                    />
                                    <p className="text-[10px] relative z-20">
                                        Đã dùng: 9985 lượt
                                    </p>
                                </div>
                            </div>

                            {/* RIGHT */}
                            <div className="flex flex-col flex-1 gap-4">
                                <div className="flex flex-col gap-2">
                                    <div className="flex justify-between items-center">
                                        <p className="text-[18px] !mb-0">
                                            <strong>Nội dung</strong>
                                        </p>

                                        {/* chua thoa dieu kien */}
                                        {/* <div className="h-5 w-[50%] max-w-[60%] flex-1 rounded-[20px] bg-[#F0F0F0] flex items-center justify-center relative overflow-hidden">
                                            <div
                                                className="absolute inset-0 z-1 transition-all bg-[#F0F0F0]"
                                                style={{ width: "0%" }}
                                            />
                                            <p className="text-[12px] relative z-20 line-clamp-1 px-2 text-black !mb-0">
                                                Chỉ còn vài điều kiện nữa, bạn thỏa được mã giảm giá
                                            </p>
                                        </div> */}

                                        {/* da thoa dieu kien */}
                                        <div className="h-5 w-[50%] max-w-[60%] flex-1 rounded-[20px] bg-[#F0F0F0] flex items-center justify-center relative overflow-hidden">
                                            <div
                                                className="absolute inset-0 z-1 transition-all bg-[var(--primary-color)]"
                                                style={{ width: "100%" }}
                                            />
                                            <p className="text-[12px] relative z-20 line-clamp-1 px-2 text-white">
                                                Bạn đã thỏa toàn bộ điều kiện của mã giảm giá
                                            </p>
                                        </div>
                                    </div>

                                    <p className="font-[ggsr] text-[16px] !mb-0">
                                        Không giới hạn khi thanh toán chuyển khoản ngân hàng
                                    </p>
                                </div>

                                <details open className="group">
                                    <summary className="list-none [&::-webkit-details-marker]:hidden w-full flex items-center gap-2 justify-between cursor-pointer">
                                        <p className="text-[16px] font-semibold ">
                                            Điều kiện sử dụng
                                        </p>
                                        <svg
                                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium transition-all group-open:rotate-180 text-[var(--primary-color)] css-vubbuv"
                                            focusable="false"
                                            aria-hidden="true"
                                            viewBox="0 0 24 24"
                                            data-testid="KeyboardArrowDownIcon"
                                        >
                                            <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                                        </svg>
                                    </summary>

                                    <div className="flex flex-col gap-2 mt-2">
                                        <div className="flex gap-2">
                                            <div className="h-auto w-[1px] bg-[#3FB877] ml-2" />
                                            <p className="font-[ggsr] text-[16px] max-h-[200px] overflow-auto [&_a]:[text-decoration:revert] [&_a]:[color:revert]">
                                                <ul className="list-disc">
                                                    <li>
                                                        Voucher giảm 0.5% áp dụng cho phương thức thanh toán chuyển khoản ngân hàng
                                                    </li>
                                                    <li>
                                                        Chỉ áp dụng cho đơn hàng có từ 3 loại sản phẩm
                                                    </li>
                                                </ul>
                                            </p>
                                        </div>

                                        <div className="flex flex-col gap-2 w-full">
                                            <div className="flex flex-col gap-2 w-full [--inprogress-color:#FAAD14] [--unactive-color:#F5222D] [--done-color:var(--primary-color)]">
                                                <div className="flex items-center gap-2">
                                                    <svg
                                                        width="16"
                                                        height="17"
                                                        viewBox="0 0 16 17"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M8 0.5C6.41775 0.5 4.87103 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346639 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0822 16 8.5C16 6.37827 15.1571 4.34344 13.6569 2.84314C12.1566 1.34285 10.1217 0.5 8 0.5Z"
                                                            fill="var(--done-color)"
                                                        />
                                                        <path
                                                            d="M12.565 7.17498L7.75418 12.2253C7.62316 12.3629 7.46574 12.4726 7.29132 12.5479C7.1169 12.6232 6.92909 12.6625 6.73912 12.6635H6.733C6.54414 12.6634 6.3572 12.6255 6.18325 12.552C6.00929 12.4784 5.85187 12.3707 5.7203 12.2352L3.1683 9.60604C3.02951 9.47529 2.91865 9.31778 2.8424 9.14301C2.76615 8.96825 2.7261 8.77985 2.72465 8.58918C2.7232 8.39851 2.7604 8.20952 2.83398 8.03362C2.90757 7.85772 3.01603 7.69854 3.15282 7.5657C3.2896 7.43286 3.45188 7.32911 3.62986 7.2607C3.80784 7.19228 3.99783 7.16064 4.18838 7.16766C4.37892 7.17468 4.56607 7.22023 4.73853 7.30156C4.91099 7.38289 5.06519 7.49831 5.19183 7.64086L6.72124 9.21686L10.5184 5.2291C10.6462 5.09472 10.7992 4.98682 10.9686 4.91156C11.1381 4.8363 11.3207 4.79516 11.5061 4.79049C11.6915 4.78581 11.8759 4.81769 12.049 4.88431C12.222 4.95093 12.3803 5.05098 12.5146 5.17874C12.649 5.30651 12.7569 5.4595 12.8322 5.62897C12.9074 5.79844 12.9486 5.98107 12.9533 6.16643C12.9579 6.3518 12.9261 6.53628 12.8594 6.70932C12.7928 6.88237 12.6928 7.0406 12.565 7.17498Z"
                                                            fill="white"
                                                        />
                                                    </svg>

                                                    <span className="text-[var(--done-color)] text-[14px] leading-[17px]">
                                                        Đã thêm vào giỏ 1/1 sản phẩm
                                                    </span>
                                                </div>

                                                <div className="h-[6px] transition-all min-w-10 rounded-[10px] w-full bg-[#D9D9D9] overflow-hidden">
                                                    <div
                                                        className="h-full bg-[var(--done-color)]"
                                                        style={{ width: "100%" }}
                                                    />
                                                </div>

                                                <div className="flex gap-2 pl-2">
                                                    <div className="border-l-[1px] border-[var(--done-color)]" />
                                                    <p className="font-[ggsr] text-[14px] leading-[22px] py-1">
                                                        Đã thêm vào giỏ 1/1 sản phẩm Hapacol 250mg dhg (H/24g/1.5gr)
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-2 w-full">
                                            {/* PROGRESS 1 */}
                                            <div className="flex flex-col gap-2 w-full [--inprogress-color:#FAAD14] [--unactive-color:#F5222D] [--done-color:var(--primary-color)]">
                                                <div className="flex items-center gap-2">
                                                    <div className="h-4 w-4 rounded-full border-[2px] border-[var(--inprogress-color)]" />
                                                    <span className="text-[var(--inprogress-color)] text-[14px] leading-[17px]">
                                                        Đã thỏa 1/3 loại sản phẩm
                                                    </span>
                                                </div>

                                                <div className="h-[6px] transition-all min-w-10 rounded-[10px] w-full bg-[#D9D9D9] overflow-hidden">
                                                    <div
                                                        className="h-full bg-[var(--inprogress-color)]"
                                                        style={{ width: "33%" }}
                                                    />
                                                </div>

                                                <div className="flex gap-2 pl-2">
                                                    <div className="border-l-[1px] border-dashed border-[var(--inprogress-color)]" />
                                                    <p className="font-[ggsr] text-[14px] leading-[22px] py-1">
                                                        Mua 1/3 loại sản phẩm để sử dụng mã
                                                    </p>
                                                </div>
                                            </div>

                                            {/* PROGRESS 2 */}
                                            <div className="flex flex-col gap-2 w-full [--inprogress-color:#FAAD14] [--unactive-color:#F5222D] [--done-color:var(--primary-color)]">
                                                <div className="flex items-center gap-2">
                                                    <div className="h-4 w-4 rounded-full border-[2px] border-[var(--unactive-color)]" />
                                                    <span className="text-[14px] leading-[17px] text-[var(--unactive-color)]">
                                                        Chưa thỏa hình thức thanh toán Chuyển khoản (Giảm 0.5%)
                                                    </span>
                                                </div>

                                                <div className="h-[6px] transition-all min-w-10 rounded-[10px] w-full bg-[#D9D9D9] overflow-hidden">
                                                    <div
                                                        className="h-full"
                                                        style={{ width: "0%" }}
                                                    />
                                                </div>

                                                <div className="flex gap-2 pl-2">
                                                    <div className="border-l-[1px] border-dashed border-[var(--unactive-color)]" />
                                                    <p className="font-[ggsr] text-[14px] leading-[22px] py-1">
                                                        Hình thức thanh toán Chuyển khoản (Giảm 0.5%)
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </details>

                                <i className="text-red-500 mt-1">
                                    * Mua thêm 2 loại sản phẩm để sử dụng mã
                                </i>
                            </div>
                        </div>

                        <div
                            className="w-full py-[15px] px-5 flex justify-center rounded flex-col space-y-5 bg-white mx-2 !w-auto"
                            style={{
                                background:
                                    "linear-gradient(rgb(229, 46, 46) 0%, rgb(215, 76, 30) 50%, rgb(231, 115, 0) 100%)",
                            }}
                        >
                            <div className="flex gap-3 items-center justify-center !mb-0">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: "0px",
                                            padding: "0px",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2740%27%20height=%2740%27/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: "0px",
                                                margin: "0px",
                                                padding: "0px",
                                            }}
                                        />
                                    </span>

                                    <img
                                        src="https://thuocsi.vn/icons/icon-money-1.svg"
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: "0px",
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: "0px",
                                            height: "0px",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                        }}
                                    />
                                </span>

                                <h2 className="text-[28px] font-medium text-white text-center !mb-0">
                                    Sản phẩm áp dụng khuyến mãi
                                </h2>
                            </div>

                            <div className="bg-white rounded-[8px] py-[10px] px-3 flex space-x-1">
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                    focusable="false"
                                    aria-hidden="true"
                                    viewBox="0 0 24 24"
                                    data-testid="SearchIcon"
                                >
                                    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                                </svg>

                                <input
                                    track-input-search=""
                                    refer-data-root-voucher="code"
                                    type="text"
                                    placeholder="Tìm kiếm sản phẩm"
                                    className="outline-none border-none flex flex-1"
                                    value=""
                                    onChange={() => { }}
                                />
                            </div>
                        </div>

                        <ListProduct />

                        <div className="styles_pagiContainer__B0imj MuiBox-root css-1vwfmvr">
                            <nav
                                aria-label="pagination navigation"
                                className="MuiPagination-root jss99"
                            >
                                <ul className="MuiPagination-ul">
                                    <li>
                                        <button
                                            className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page Mui-disabled Mui-disabled"
                                            tabIndex={-1}
                                            type="button"
                                            disabled
                                            aria-label="Go to previous page"
                                        >
                                            <svg
                                                className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                focusable="false"
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                            >
                                                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                            </svg>
                                        </button>
                                    </li>

                                    <li>
                                        <button
                                            className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page Mui-selected"
                                            tabIndex={0}
                                            type="button"
                                            aria-current="true"
                                            aria-label="page 1"
                                        >
                                            1
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </li>

                                    <li>
                                        <button
                                            className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                            tabIndex={0}
                                            type="button"
                                            aria-label="Go to page 2"
                                        >
                                            2
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </li>

                                    <li>
                                        <button
                                            className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                            tabIndex={0}
                                            type="button"
                                            aria-label="Go to page 3"
                                        >
                                            3
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </li>

                                    <li>
                                        <button
                                            className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                            tabIndex={0}
                                            type="button"
                                            aria-label="Go to page 4"
                                        >
                                            4
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </li>

                                    <li>
                                        <button
                                            className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                            tabIndex={0}
                                            type="button"
                                            aria-label="Go to page 5"
                                        >
                                            5
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </li>

                                    <li>
                                        <div className="MuiPaginationItem-root MuiPaginationItem-ellipsis">
                                            …
                                        </div>
                                    </li>

                                    <li />

                                    <li>
                                        <button
                                            className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                            tabIndex={0}
                                            type="button"
                                            aria-label="Go to next page"
                                        >
                                            <svg
                                                className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                focusable="false"
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                            >
                                                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                            </svg>
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
